export const judgments = [
  {
    title: "",
    url: "domestic/judgments/jpg/2010_09_22 BRAGGE JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2010_09_22 BRAGGE JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2010_09_22 BRAGGE JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2010_09_22 BRAGGE JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2011_12_20 STRAUSS JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-8.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_05_22 PURLE JUDGMENT-9.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_11_05 LEWISON JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2013_11_05 LEWISON JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2014_08_04 Matthews Judgment-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2014_08_04 Matthews Judgment-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2014_08_04 Matthews Judgment-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2014_08_04 Matthews Judgment-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2014_08_04 Matthews Judgment-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_02_13 McCahill Judgment-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_02_13 McCahill Judgment-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_02_13 McCahill Judgment-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_02_13 McCahill Judgment-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_02_13 McCahill Judgment-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_02_13 McCahill Judgment-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_02_13 McCahill Judgment-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_10 ORME JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-14.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-15.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-16.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-17.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-18.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-19.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-20.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-21.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-22.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-23.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_03_23 MCCAHILL JUDGMENT-24.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-8.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_06_11 BIRSS JUDGMENT-9.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_12_17 FLOYD JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_12_17 FLOYD JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2015_12_17 FLOYD JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2016_11_17 PATTEN JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2016_11_17 PATTEN JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2016_11_17 PATTEN JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2016_11_17 PATTEN JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-14.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-15.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_03_09 MATTHEWS PROCEEDINGS-16.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_04_25 MATTHEWS JUDGMENT-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_10_06 ASPLIN JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2017_11_22 SMITH JUDGMENT-8.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT1-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT1-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT1-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT1-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT2-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT2-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT2-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT2-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_03_09 COPE JUDGMENT2-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_11_13 CORRIGAN JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2018_12_06 COLLINS PROCEEDINGS-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2019_08_08 MATTHEWS JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-14.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH JUDGMENT-15.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-14.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-15.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-16.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-17.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-18.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-19.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-20.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-21.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-22.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-23.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-24.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-25.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-26.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-27.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-28.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2020_01_16 WALSH PROCEEDINGS-29.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_01_22 MATTHEWS JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-14.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-15.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-16.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-17.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-18.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-19.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-20.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-21.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-22.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-23.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_01 MATTHEWS JUDGMENT-24.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT ECRO-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT ECRO-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT ECRO-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT ECRO-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT ECRO-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN PROCEEDINGS-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN PROCEEDINGS-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN PROCEEDINGS-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN PROCEEDINGS-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN PROCEEDINGS-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN PROCEEDINGS-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_02_10 MORGAN PROCEEDINGS-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_08_26 COTTER JUDGMENT-8.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_11_29 MATTHEWS JUDGMENT-14.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-14.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-15.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-16.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-17.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-18.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-19.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-20.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-21.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-22.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-23.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-24.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-25.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-26.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-27.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-28.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-29.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2021_12_15 MATTHEWS JUDGMENT NEGLIGENCE-30.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_01_09 BOSMAN JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_01_09 BOSMAN JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_01_09 BOSMAN JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_01_09 BOSMAN JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_01_09 BOSMAN JUDGMENT-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_01_09 BOSMAN JUDGMENT-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_01_09 BOSMAN JUDGMENT-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-8.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_03_10 MILES JUDGMENT-9.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-10.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-11.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-12.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_04_10 BOSMAN JUDGMENT-13.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_05_10 MATTHEWS JUDGMENT-1.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_05_10 MATTHEWS JUDGMENT-2.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_05_10 MATTHEWS JUDGMENT-3.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_05_10 MATTHEWS JUDGMENT-4.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_05_10 MATTHEWS JUDGMENT-5.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_05_10 MATTHEWS JUDGMENT-6.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_05_10 MATTHEWS JUDGMENT-7.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-01.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-02.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-03.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-04.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-05.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-06.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-07.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-08.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-09.jpg"
  },
  {
    title: "",
    url: "domestic/judgments/jpg/2023_10_23 RALTON JUDGMENT-10.jpg"
  },
];